<template>
  <div class="video-container ff ff-center" :class="{ 'is-playing' : isPlaying }">
    <transition name="fade">
      <div
        v-if="!isPlaying"
        class="video-preview" 
        :style="'background-image: url(' + previewImage + ');'" 
        v-on:click="isPlaying = !isPlaying"
      >
        <div class="video-overlay ff ff-center">
          <div class="video-play-icon ff ff-center">
            <icon name="icon-play" color="white" size=40 /> 
          </div>
        </div>
      </div>
    </transition>
    <youtube 
      v-if="isPlaying"
      :video-id="extractVideoId" 
      player-width="100%" 
      player-height="100%"
      :player-vars="{autoplay: 1}"
      class="video-wrapper"
    ></youtube>
  </div>
</template>

<script>
  
  export default {
    name: "Video",
    props: {
      videoId: String,
      previewImage: String
    },
    data() {
      return {
        isPlaying: false
      }
    },
    computed: {
      extractVideoId() {
        return this.$youtube.getIdFromURL(this.videoId);
      }
    },
    methods: {
      
    }
  }
</script>